/*
document.addEventListener('DOMContentLoaded', function() {
  const gallerySelector = '.product-single__media-list, .product__media-list';

  function playActiveVideo() {
    const gallery = document.querySelector(gallerySelector);
    if(!gallery) return;

    const activeSlide = gallery.querySelector('.splide__slide.is-active');
    if(!activeSlide) return;

    const video = activeSlide.querySelector('video');
    if(video){
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      const promise = video.play();
      if(promise !== undefined) promise.catch(()=>console.log('Autoplay blockiert'));
    }
  }

  setTimeout(playActiveVideo, 1000);

  const gallery = document.querySelector(gallerySelector);
  if(gallery){
    const observer = new MutationObserver(() => setTimeout(playActiveVideo, 100));
    observer.observe(gallery, { attributes: true, subtree: true, attributeFilter: ['class'] });
  }

  document.addEventListener('variant:change', () => setTimeout(playActiveVideo, 500));
});
*/

document.addEventListener('DOMContentLoaded', () => {

  const videos = document.querySelectorAll('.product-gallery [type="video"]');
  videos.forEach(video => {
    console.log('video');
    video.querySelector('img').style.opacity = 0;
    video.querySelector('video').style.opacity = 1;
    video.style.setProperty('--play-button-background', 'transparent');
  });

});
